// extracted by mini-css-extract-plugin
module.exports = {"primary":"Link_primary__1M0EX","mini":"Link_mini__1E9QW","buttonText":"Link_buttonText__2MCCf","add":"Link_add__1U6Uc","addIcon":"Link_addIcon__1ef_b"};